export const PopupContentType = Object.freeze({
    Table: 'table',
    Text: 'text',
});

